import {FC, useState} from 'react'
import ReactSlider from 'react-slider'
import {onlyDigits} from "../../lib/helpers";

interface Props {
    booking?: Booking,
    setBooking: Function
}

const Mileage: FC<Props> = ({ booking, setBooking}) => {
    const [mileage, setMileage] = useState<any>(booking.car.mileage);

    let active = false

    for(let i = 0; i < booking.serviceArray.length; i++) {
        const service = booking.serviceArray[i]

        if (service.mandatory_mileage)
            active = true
    }

    if(!active)
        return

    const updateMileage = (value: number) => {
        setMileage(value)
        booking.car.mileage = value
        setBooking({
            ...booking,
        })
    }

    const updateMileageField = (e: any) => {
        if(!onlyDigits(e.target.value))
            return

        setMileage(e.target.value)
        booking.car.mileage = e.target.value
        setBooking({
            ...booking,
        })
    }

    return (
        <div className="row">
            <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 col-xxs-12">
                <div className="text-content">
                    <h2 className="required">Mätarställning</h2>
                    <p>Var god ange mätarställning</p>
                </div>
            </div>
            <div className="main-bg col-lg-8 pt-3 col-md-8 col-sm-12 col-xs-12 col-xxs-12">
                <div className="input-outer wco-booking-car-milage">
                    <span className="error-message">Var god ange mätarställning</span>
                    <div>
                        <div className={"rangeslider-wrap"}>
                            <span className="min-value">0 mil</span>
                            <span className="max-value">30 000 mil</span>
                            <ReactSlider
                                className="milage-slider"
                                max={30000}
                                min={0}
                                step={50}
                                onChange={updateMileage}
                                value={mileage}
                                renderThumb={(props, state) => <div {...props}>{state.valueNow}</div>}
                            />
                        </div>
                        <input className="mileage-field" type="text" value={mileage} onChange={updateMileageField} />
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Mileage
